var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { bordered: false } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingList,
                      expression: "loadingList",
                    },
                  ],
                  ref: "table",
                  staticClass: "mt25",
                  attrs: {
                    data: _vm.levelLists,
                    size: "small",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", prop: "id", width: "80" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "通知名称", prop: "type" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "小程序订阅消息模板", prop: "routineId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: scope.row.routineId
                                  ? "status-configured"
                                  : "status-unconfigured",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.routineId ? "已配置" : "未配置"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "设置", prop: "id" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:system:notification:detail"],
                                    expression:
                                      "['admin:system:notification:detail']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setting(scope.row)
                                  },
                                },
                              },
                              [_vm._v("修改配置")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "通知详情",
            visible: _vm.centerDialogVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订阅消息模板" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择订阅消息模板" },
                      on: { change: _vm.handleTemplateChange },
                      model: {
                        value: _vm.form.routineId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "routineId", $$v)
                        },
                        expression: "form.routineId",
                      },
                    },
                    _vm._l(_vm.subscribeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.subscribeTemplateInfo && _vm.subscribeTemplateInfo.id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "模板ID" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.subscribeTemplateInfo.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.subscribeTemplateInfo, "id", $$v)
                          },
                          expression: "subscribeTemplateInfo.id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.subscribeTemplateInfo && _vm.subscribeTemplateInfo.name
                ? _c(
                    "el-form-item",
                    { attrs: { label: "模板名称" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.subscribeTemplateInfo.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.subscribeTemplateInfo, "name", $$v)
                          },
                          expression: "subscribeTemplateInfo.name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.subscribeTemplateInfo && _vm.subscribeTemplateInfo.content
                ? _c(
                    "el-form-item",
                    { attrs: { label: "模板内容" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.subscribeTemplateInfo.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.subscribeTemplateInfo, "content", $$v)
                          },
                          expression: "subscribeTemplateInfo.content",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isRoutine,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isRoutine", $$v)
                        },
                        expression: "form.isRoutine",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("开启"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }